import { BlogSection } from "@/types/blog";

export const virusFuehrung: BlogSection = {
  id: "virus-fuehrung",
  title: "Vom Virus zur Führung: Die biologische Realität",
  content: `
    <p>Ein viraler Infekt ist kein seelischer Hilferuf, sondern ein biologisches Ereignis. Viren aktivieren Immunzellen, die Signalmoleküle freisetzen. Diese Botenstoffe steuern Fieber, Müdigkeit, Appetit und Motivation. Ein evolutionär sinnvolles Verhaltensmuster, das Energie spart und Heilung fördert.</p>
    
    <p>Der entscheidende Punkt: Dieses Verhalten wird vom Gehirn koordiniert, nicht vom Virus verursacht. Der Hypothalamus empfängt Immun-Signale und ordnet daraufhin Prioritäten neu: weniger Aktivität, mehr Regeneration.</p>
    
    <p>Das subjektive Erleben von „Ich kann gerade nicht mehr" ist kein mentaler Zusammenbruch, sondern Ausdruck einer neuroimmunologischen Steuerung.</p>
    
    <p>Man kann den Virus nicht coachen, aber man kann mit dem Körper kooperieren. Krankheit ist dann keine Niederlage, sondern eine intelligente Umverteilung von Energie.</p>
    
    <p>Doch genau diese biologische Realität kollidiert oft mit unserem mentalen Selbstbild. Denn wenn der Körper stoppt, meldet sich bei vielen Menschen nicht zuerst Erleichterung, sondern Schuld.</p>
  `
};
